var _excluded = ["isViewMode", "isEditable", "isLoading", "placeholder", "footer", "isReadOnly", "isDisabled", "isInvalid", "numberOfRows", "maxChars", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useState } from 'react';
import { Container, Group } from '../../../containers';
import { Loader } from '../../../foundations/Loader';
import { forwardRef, useTestId } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { _NotSupportedBadge, Box } from '../../internal';
import { useFormControlContext } from '../../internal/FormControl';
import { InputGroup } from '../../internal/InputGroup';
import { Checkbox } from '../Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TextArea = forwardRef((_ref, ref) => {
  var {
    isViewMode,
    isEditable = true,
    isLoading,
    placeholder,
    footer,
    isReadOnly,
    isDisabled,
    isInvalid,
    numberOfRows,
    maxChars: maxCharsProp,
    'data-testid': dataTestId = 'text-area-input'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var isEnabled = !isReadOnly && !isDisabled && isEditable && !isLoading;
  var [isInputFocus, setInputFocus] = useState(false);
  var style = useMultiStyleConfig('TextArea', {});
  var {
    maxChars
  } = useFormControlContext();
  var getTestId = useTestId(dataTestId);

  if (isViewMode) {
    return /*#__PURE__*/_jsx(_NotSupportedBadge, {
      details: {
        componentName: 'TextArea',
        props: {
          isViewMode
        }
      }
    });
  }

  return /*#__PURE__*/_jsx(InputGroup, {
    __css: style['container'],
    "aria-disabled": isDisabled,
    "data-editable": isEditable,
    "data-readonly": isReadOnly || isLoading,
    "aria-invalid": isInvalid,
    "data-focus": isEnabled && isInputFocus || undefined,
    onFocus: () => setInputFocus(true),
    onBlur: () => setInputFocus(false),
    onMouseDown: !isEnabled ? e => e.preventDefault() : undefined,
    children: /*#__PURE__*/_jsxs(Group, {
      spacing: "none",
      hasDivider: true,
      variant: "vertical",
      children: [/*#__PURE__*/_jsxs(Group, {
        width: "full",
        spacing: "xs",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
          as: "textarea",
          "data-component": "TextArea",
          "aria-label": "text area input"
        }, getTestId()), {}, {
          "data-loading": isLoading || undefined,
          placeholder: placeholder,
          sx: style['field'],
          "data-editable": isEditable,
          "aria-disabled": isDisabled,
          "aria-readonly": isReadOnly,
          "aria-invalid": isInvalid,
          disabled: isDisabled,
          readOnly: isReadOnly
        }, isEditable && props), {}, {
          rows: numberOfRows || 4,
          maxLength: maxCharsProp !== null && maxCharsProp !== void 0 ? maxCharsProp : maxChars // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ,
          ref: ref
        })), isLoading && /*#__PURE__*/_jsx(Container, {
          width: "fit-content",
          paddingRight: "s",
          children: /*#__PURE__*/_jsx(Loader, {})
        })]
      }), footer && !isEditable && /*#__PURE__*/_jsx(Box, {
        __css: style['footerContainer'],
        children: /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, !isEditable && props), footer))
      })]
    })
  });
});
TextArea.displayName = 'TextArea';
//# sourceMappingURL=TextArea.js.map